/* Copyright 2011-2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/sniff",
    "dojo/on",
    "dojo/keys",
    "mw-form/TextField",
    "MW/uiframework/utils",
    "../mixins/property/MnemonicMixin",
    "../mixins/property/MnemonicKeyNavDirectionMixin",
    "../mixins/AcceptFocusMixin",
    "../mixins/ColumnWidthMixin",
    "../mixins/property/TypeMixin",
    "../mixins/property/DescriptionOverrideMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "mw-form/mixins/property/ValidationMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, lang, has, on, keys, TextField, utils, MnemonicMixin, MnemonicKeyNavDirectionMixin, AcceptFocusMixin, ColumnWidthMixin, TypeMixin,
             DescriptionOverrideMixin, ShortcutMixin, ValidationMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([TextField, MnemonicMixin, MnemonicKeyNavDirectionMixin, AcceptFocusMixin, ColumnWidthMixin, TypeMixin,
        DescriptionOverrideMixin, ShortcutMixin, ValidationMixin]), {
        visualFamily: "default",
        width: 150,
        height: 22,
        mnemonicKeyNavDirection: "vertical",
        _scaleToParentWidth: true,

        //Overriding Consolidated TextField: Adding ESC behavior
        _onKeyUp: function (e) {
            if (e.keyCode === keys.ESCAPE) {
                if (this.get("editable")) {
                    this.inputNode.value = this.get("value");
                    this.emit("textcancelled", {
                        mwEventData: {
                            text: this.get("value")
                        }
                    });
                }
                this.emit("restorefocustolastnonrefuseelement");
            } else  if (e.keyCode === keys.ENTER) {
                if (this.get("editable") && this.get("value") === this.inputNode.value) {
                    this.emit("recommit", {
                        mwEventData: {
                            text: this.get("value")
                        }
                    });
                }
                this.emit("restorefocustolastnonrefuseelement");
                this.emit("commit", {});
            }
            this.inherited(arguments);
        },
        //Override typing event mixin of consolidated widget to emit "text" instead of "currentContent"
        _triggerTypingEvent: function (value) {
            if (this.get("editable")) {
                this.emit("typing", {
                    mwEventData: {
                        text: value
                    }
                });
            }
        },

        postCreate: function () {
            this.inherited(arguments);
            //On click we select entire text and if text has incorrect spelling after selection
            this.domNode.setAttribute("spellcheck", "false");
            this.own(on(this.inputNode, "focus", lang.hitch(this, "_handleInputNodeFocus")));
        },

        //Select entire text
        _handleInputNodeFocus: function (event) {
            if (this.get("editable") !== false) {
                var hasIE = utils.detectIE();
                if (hasIE) {
                    //for select to work on IE, go behind browser
                    setTimeout(lang.hitch(this, function () {
                        this.inputNode.select();
                        return false;
                    }, 0));
                } else {
                    this.inputNode.select();
                }
            }
        },

        _onFocus: function () {
            this.inherited(arguments);
            this.emit("focusgained", {mwEventData: {text: this.inputNode.value}});
        },

        _onBlur: function () {
            this.inherited(arguments);
            this.emit("focuslost", {mwEventData: {text: this.inputNode.value}});
        }

    });

});
